export default __webpack_public_path__ + "static/l1-1df51046cd0201b3570ba513456f505a.png";